<script setup lang="ts">
import { getUrl } from '@/lib/helpers'

const siteName = 'CSM/online'
const siteDesc = 'CSM/online to największa baza pieśni uwielbienia w Polsce i rozwojowe narzędzie, które skutecznie pomoże przygotować Ci się na próbę i nabożeństwo.'
const siteUrl = getUrl()
const siteImage = getUrl('/opengraph.png')

useHead({
  htmlAttrs: { lang: 'pl' },
  titleTemplate(title) {
    if (!title) return siteName
    return title === siteName ? title : `${title} | ${siteName}`
  },
})

useSeoMeta({
  description: siteDesc,
  ogTitle: siteName,
  ogDescription: siteDesc,
  ogType: 'website',
  ogUrl: siteUrl,
  ogImage: siteImage,
  ogLocale: 'pl_PL',
  twitterCard: 'summary_large_image',
  twitterTitle: siteName,
  twitterDescription: siteDesc,
  twitterImage: siteImage,
})

const webSiteSchema = computed(() => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteName,
  url: siteUrl,
}))

useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(webSiteSchema.value),
    },
  ],
})
</script>

<template>
  <v-app>
    <ui-navbar />
    <v-main>
      <div
        :style="{
          position: 'absolute',
          content: '',
          top: 0,
          left: 0,
          zIndex: 0,
          background: 'linear-gradient(180deg, #6D18F9 7.74%, rgba(252, 252, 253, 0.00) 99.95%)',
          width: '100%',
          minHeight: '900px',
        }"
      />
      <div
        class="position-relative pt-2 pt-sm-8"
        :style="{ zIndex: 1 }"
      >
        <router-view />
      </div>
    </v-main>
    <ui-footer />
  </v-app>
</template>
